package pwgs.ui.scenes.allowedversionsscene

import kotlinx.browser.window


class AllowedVersionsControllerFe(props: AllowedVersionsSceneProps, scene: MAllowedVersionsScene) : AAllowedVersionsControllerFe(props, scene) {

    override fun createInitialModel() : AllowedVersionsSceneModel {
        return AllowedVersionsSceneModel(listOf())
    }

    override fun init() {
        call_load()
    }

    fun onAddVersionButtonClicked() {
        model.addDialogModel = AllowedVersionsSceneAddVersionDialogModel()
        render(model)
    }

    fun onCancelAddVersionButtonClicked() {
        model.addDialogModel = null
        render(model)
    }

    fun onSubmitAddVersionButtonClicked() {
        model.addDialogModel!!.isLoading = true
        render(model)

        call_addVersion()
    }

    fun onDeleteVersionButtonClicked(ver: String) {
        if (!window.confirm("Are you sure you want to delete the version $ver?")) {
            return
        }

        model.isLoading = true
        render(model)

        call_deleteVersion(ver)
    }


}

